import { jsx as _jsx } from "react/jsx-runtime";
import { renderToString } from "react-dom/server";
import { PinOtherStoreActiveIcon } from "@jti/brand-icons/pin-other-store-active";
import { PinOtherStoreDefaultIcon } from "@jti/brand-icons/pin-other-store-default";
import { PinStoreIcon } from "@jti/brand-icons/pin-store";
import { PinStoreActiveIcon } from "@jti/brand-icons/pin-store-active";
import { PinStoreDefaultIcon } from "@jti/brand-icons/pin-store-default";
import { PinStoreNegativeIcon } from "@jti/brand-icons/pin-store-negative";
import { UiTargetIcon } from "@jti/brand-icons/ui-target";
import { isOtherStore } from "./utils/isOtherStore";
const svgDataURIHeader = "data:image/svg+xml;charset=utf-8,";
export const createImageIcon = (icon) => {
    return svgDataURIHeader + encodeURIComponent(icon);
};
export const BRAND_STORE_PIN_DARK = createImageIcon(renderToString(_jsx(PinStoreNegativeIcon, { width: 30, height: 30 })));
export const BRAND_STORE_PIN_LIGHT = createImageIcon(renderToString(_jsx(PinStoreDefaultIcon, { width: 30, height: 30 })));
export const BRAND_STORE_PIN_ACTIVE = createImageIcon(renderToString(_jsx(PinStoreActiveIcon, { width: 30, height: 30 })));
export const OTHER_STORE_PIN_DARK = createImageIcon(renderToString(_jsx(PinStoreIcon, { width: 30, height: 30 })));
export const OTHER_STORE_PIN_LIGHT = createImageIcon(renderToString(_jsx(PinOtherStoreDefaultIcon, { width: 30, height: 30 })));
export const OTHER_STORE_PIN_ACTIVE = createImageIcon(renderToString(_jsx(PinOtherStoreActiveIcon, { width: 30, height: 30 })));
export const USER_LOCATION = createImageIcon(renderToString(_jsx(UiTargetIcon, { width: 43, height: 43, fill: "#747474ff" })));
export const DEFAULT_MARKER = createImageIcon(renderToString(_jsx(PinStoreDefaultIcon, { width: 30, height: 30 })));
export const DEFAULT_MARKER_LIGHT = createImageIcon(renderToString(_jsx(PinStoreNegativeIcon, { width: 30, height: 30 })));
export const DEFAULT_MARKER_NAVER = createImageIcon(renderToString(_jsx(PinStoreNegativeIcon, { width: 30, height: 30 })));
export const ACTIVE_MARKER = createImageIcon(renderToString(_jsx(PinStoreActiveIcon, { width: 30, height: 30 })));
export const OTHER_STORE_ICON_DARK = {
    default: OTHER_STORE_PIN_DARK,
    active: OTHER_STORE_PIN_ACTIVE,
};
export const OTHER_STORE_ICON_LIGHT = {
    default: OTHER_STORE_PIN_LIGHT,
    active: OTHER_STORE_PIN_ACTIVE,
};
export const BRAND_STORE_ICON_DARK = {
    default: BRAND_STORE_PIN_DARK,
    active: BRAND_STORE_PIN_ACTIVE,
};
export const BRAND_STORE_ICON_LIGHT = {
    default: BRAND_STORE_PIN_LIGHT,
    active: BRAND_STORE_PIN_ACTIVE,
};
const STORE_ICON_MAP = {
    dark: {
        Flagship: BRAND_STORE_ICON_LIGHT,
        "Brand Store": BRAND_STORE_ICON_LIGHT,
        "Pop-up Store": BRAND_STORE_ICON_LIGHT,
        Tobacconist: OTHER_STORE_ICON_LIGHT,
        "Tobacconist with Vending Machine": OTHER_STORE_ICON_LIGHT,
        "Duty Free": OTHER_STORE_ICON_LIGHT,
        "Vending Machine": OTHER_STORE_ICON_LIGHT,
        "Bars/Cafes/Restaurants": OTHER_STORE_ICON_LIGHT,
        default: BRAND_STORE_ICON_LIGHT,
    },
    light: {
        Flagship: BRAND_STORE_ICON_DARK,
        "Brand Store": BRAND_STORE_ICON_DARK,
        "Pop-up Store": BRAND_STORE_ICON_DARK,
        Tobacconist: OTHER_STORE_ICON_DARK,
        "Tobacconist with Vending Machine": OTHER_STORE_ICON_DARK,
        "Duty Free": OTHER_STORE_ICON_DARK,
        "Vending Machine": OTHER_STORE_ICON_DARK,
        "Bars/Cafes/Restaurants": OTHER_STORE_ICON_DARK,
        default: BRAND_STORE_ICON_DARK,
    },
};
export function createStoreIconFactory(params = {}) {
    if (params.layoutVersion === "v2") {
        return getIconForStoreV2(params);
    }
    return getIconForStoreV1(params);
}
export function getIconForStoreV1({ defaultStoreIcon, theme, storeTypeOverrides = {} } = {}) {
    return (store) => {
        const { storetype } = store;
        const themeIcon = theme === "light" ? DEFAULT_MARKER_LIGHT : DEFAULT_MARKER;
        const defaultIcon = defaultStoreIcon || themeIcon;
        return {
            default: storeTypeOverrides[storetype] ?? defaultIcon,
            active: ACTIVE_MARKER,
        };
    };
}
export function getIconForStoreV2({ theme, defaultStoreIcon, storeTypeOverrides = {} } = {}) {
    return (store) => {
        const { storetype } = store;
        const themeMap = STORE_ICON_MAP[theme] ?? STORE_ICON_MAP.dark;
        if (isOtherStore(store)) {
            return themeMap[storetype] ?? OTHER_STORE_ICON_DARK;
        }
        const baseIcon = themeMap[storetype] ?? themeMap.default;
        if (storeTypeOverrides[storetype]) {
            return {
                ...baseIcon,
                default: storeTypeOverrides[storetype],
            };
        }
        if (defaultStoreIcon) {
            return {
                ...baseIcon,
                default: defaultStoreIcon,
            };
        }
        return baseIcon;
    };
}
//# sourceMappingURL=store-locator-icons.js.map